export enum PlatformFeatureType {
  MicrosoftSSO = 'MicrosoftSSO',
  LLMBlockFilteringForTrainAI = 'LLMBlockFilteringForTrainAI',
  UseAIKnowledgeLabels = 'UseAIKnowledgeLabels',
  // Replaced the old `PseudonymizeUserDataSinceUserCreation` feature flag.
  // No DB migration needed: companies that had the old flag will simply not
  // have PSNEnable in their platformFeatures array, which is the correct
  // default (PSN disabled). They can re-enable via the settings UI.
  PSNEnable = 'PSNEnable',
  AIKnowledgeHubV2 = 'AIKnowledgeHubV2',
  ConversationKeywords = 'ConversationKeywords',
  HotTopicFilterForTrainAI = 'HotTopicFilterForTrainAI',
  WebclientVoice = 'WebclientVoice',
  EmailAIStudio = 'EmailAIStudio',
  LangSmithEvaluation = 'LangSmithEvaluation',
  AutomaticRetraining = 'AutomaticRetraining',
  AutoApproveReviews = 'AutoApproveReviews',
  TrainAIV2 = 'TrainAIV2',
  MultilingualTrainAI = 'MultilingualTrainAI',
  HomeV2 = 'HomeV2',
  // Paid add-on: unlocks the Intelligence section on the Home v2 page. Absent
  // means locked, so the section renders greyed out behind an Unlock card.
  //
  // Deliberately NOT granted to companies that already held HomeV2 when this
  // shipped: every client starts locked and a super admin enables it per client
  // from Settings > Platform Settings > Home. Do not add a migration that
  // backfills it - the lockout is the intended starting state, not an oversight.
  HomeIntelligence = 'HomeIntelligence',
  ContactLookup = 'ContactLookup',
}

export enum LangSmithEvaluationFrequency {
  Weekly = 'weekly',
  Monthly = 'monthly',
}

export interface LangSmithEvaluationConfig {
  frequency: LangSmithEvaluationFrequency;
}

export interface PlatformFeaturesMetadata {
  [PlatformFeatureType.LangSmithEvaluation]?: LangSmithEvaluationConfig;
}
